import { call, put, takeEvery } from "redux-saga/effects";
import { appInitFailure, appInitSuccess } from "./appActions";
import { APP_INIT_START } from "./appConstants";
import { failurePut } from "./failurePut";
import { getRequest } from "./request";
import { loginSuccess } from "../modules/Auth/authActions";

export function* appInitStartSaga() {
    try {
        const data = yield call(getRequest, '/init');

        if (data.user) {
            yield put(loginSuccess(data.user));
        }
        yield put(appInitSuccess(data));
    } catch (e) {
        yield call(failurePut, e, appInitFailure);
    }
}

export function* appSagas() {
    yield takeEvery(APP_INIT_START, appInitStartSaga);
}
